<div
class="modal fade"
id="imageModal"
data-bs-backdrop="static"
data-bs-keyboard="false"
tabindex="-1"
aria-labelledby="imageModalLabel"
aria-hidden="true"
>
<div class="modal-dialog modal-lg modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title fs-5" id="imageModalLabel">Update Profile</h1>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="imageId" class="form-label">Select Image</label>
        <input
          class="form-control"
          id="imageId"
          #file
          type="file"
          accept="image/*"
          name="imageId"
          (change)="
            file.files &&
              onFileChanged($event)
          "
        />
      </div>

      <!-- Buttons Row -->
      <div class="button-row mb-3" *ngIf="showCropper">
        <button
          (click)="zoomIn()"
          [class.enabled]="transform.flipV"
          class="btn btn-sm btn-outline-primary me-2"
          title="Zoom In"
        >
          <i class="fadeIn animated bx bx-zoom-in"></i>
        </button>
        <button
          (click)="zoomOut()"
          [class.enabled]="transform.flipV"
          class="btn btn-sm btn-outline-primary me-1"
          title="Zoom Out"
        >
          <i class="fadeIn animated bx bx-zoom-out"></i>
        </button>
        <button
          (click)="rotateRight()"
          [class.enabled]="transform.flipV"
          class="btn btn-sm btn-outline-primary me-1"
          title="Rotate Right"
        >
          <i class="fadeIn animated bx bx-rotate-right"></i>
        </button>
        <button
          (click)="rotateLeft()"
          [class.enabled]="transform.flipV"
          class="btn btn-sm btn-outline-primary me-1"
          title="Rotate Left"
        >
          <i class="fadeIn animated bx bx-rotate-left"></i>
        </button>
        <button
          (click)="flipHorizontal()"
          [class.enabled]="transform.flipH"
          class="btn btn-sm btn-outline-primary me-1"
          title="Flip Horizontal"
        >
          Flip Horizontal
        </button>
        <button
          (click)="flipVertical()"
          [class.enabled]="transform.flipV"
          class="btn btn-sm btn-outline-primary me-1"
          title="Flip Vertical"
        >
          Flip Vertical
        </button>
      </div>

      <!-- Preview and Cropper Row -->
      <div class="row preview-row">
        <div class="col-md-6">
          <div class="cropper-wrapper">
            <image-cropper
              [imageChangedEvent]="imageChangedEvent"
              [imageURL]="imageURL"
              [hidden]="hidden"
              [disabled]="disabled"
              [alignImage]="alignImage"
              [roundCropper]="roundCropper"
              [backgroundColor]="backgroundColor"
              imageAltText="Alternative image text"
              [allowMoveImage]="allowMoveImage"
              [hideResizeSquares]="hideResizeSquares"
              [canvasRotation]="canvasRotation"
              [aspectRatio]="aspectRatio"
              [containWithinAspectRatio]="containWithinAspectRatio"
              [maintainAspectRatio]="maintainAspectRatio"
              [cropperStaticWidth]="cropperStaticWidth"
              [cropperStaticHeight]="cropperStaticHeight"
              [cropperMinWidth]="cropperMinWidth"
              [cropperMinHeight]="cropperMinHeight"
              [cropperMaxWidth]="cropperMaxWidth"
              [cropperMaxHeight]="cropperMaxHeight"
              [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
              [(transform)]="transform"
              [onlyScaleDown]="true"
              format="png"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded()"
              (cropperReady)="cropperReady($event)"
              (loadImageFailed)="loadImageFailed()"
              (transformChange)="transformChange($event)"
              output="base64"
            ></image-cropper>
          </div>
        </div>
        <div class="col-md-6" *ngIf="showCropper">
          <p class="fw-bold">Preview</p>
          <img
            *ngIf="croppedImage"
            [src]="croppedImage"
            alt="Cropped Preview"
            class="cropped-preview"
          />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary app-btn me-2 px-4"
        [disabled]="!croppedImage"
        (click)="saveCroppedImage()"
        data-bs-dismiss="modal"
      >
        Save
      </button>

      <button
        type="button"
        class="btn btn-sm btn-outline-secondary app-btn me-2 px-4"
        data-bs-dismiss="modal"
        (click)="cancelCropping()"
      >
        Close
      </button>
    </div>
  </div>
</div>
</div>